import { CollapseProps } from 'antd';
import { FormikProps } from 'formik';

import { MFilter } from '@Components/Base';
import { useAppSelector } from '@Hooks/index';
import { DateRange, Input, MultiSelect } from '@Components/Filters';

import { FilterForm } from './types';
import {
  getLeaveStatusLabels,
  getLeaveTypeLabels,
} from '../store/selectors/leaveRequestSelector';

interface FiltersProps {
  formik: FormikProps<FilterForm>;
  showError?: boolean;
}

const Filters: React.FC<FiltersProps> = ({ formik, showError = false }) => {
  const leaveTypes = useAppSelector(getLeaveTypeLabels);
  const statuses = useAppSelector(getLeaveStatusLabels);

  const items: CollapseProps['items'] = [
    {
      id: 'LEAVE TYPE',
      label: 'Leave Type',
      children: (
        <MultiSelect<FilterForm>
          formik={formik}
          formikKey="leaveTypes"
          options={leaveTypes}
        />
      ),
    },
    {
      id: 'DATE RANGE',
      label: 'Date Range',
      children: (
        <DateRange<FilterForm>
          formik={formik}
          fromKey="dateFrom"
          toKey="dateTo"
        />
      ),
    },
    {
      id: 'TOTAL NO OF DAYS',
      label: 'Total no. of days',
      children: <Input<FilterForm> formik={formik} formikKey="totDays" />,
    },
    {
      id: 'TICKET REIMBURSEMENT REQUIRED',
      label: 'Ticket Reimbursement Required',
      children: (
        <MultiSelect<FilterForm>
          formik={formik}
          formikKey="ticketReimbursementRequired"
          options={['Yes', 'No']}
        />
      ),
    },
    {
      id: 'PASSPORT REQUIRED',
      label: 'Passport Required',
      children: (
        <MultiSelect<FilterForm>
          formik={formik}
          formikKey="passportRequired"
          options={['Yes', 'No']}
        />
      ),
    },
    {
      id: 'HOME COUNTRY CONTACT NUMBER',
      label: 'Home Country Contact Number',
      children: (
        <Input<FilterForm>
          formik={formik}
          formikKey="homeCountryContactNumber"
        />
      ),
    },
    {
      id: 'REPLACEMENT EMPLOYEE NUMBER',
      label: 'Replacement Employee Number',
      children: (
        <Input<FilterForm>
          formik={formik}
          formikKey="replacementEmployeeNumber"
        />
      ),
    },
    {
      id: 'STATUS',
      label: 'Status',
      children: (
        <MultiSelect<FilterForm>
          formik={formik}
          formikKey="statuses"
          options={statuses}
          showSearch
        />
      ),
    },
  ];

  return (
    <MFilter<FilterForm> showError={showError} formik={formik} items={items} />
  );
};

export default Filters;
